/**
 * Created by Alex Aguilar on 7/18/2016.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .factory('flightTimeService', flightTimeService)

    flightTimeService.$inject = ['$http', 'CONFIG', 'messageService'];

    function flightTimeService($http, CONFIG, messageService){
        var urlBase = CONFIG.API_URL + '/' + CONFIG.API_FLIGHT_CONTROL + '/' + CONFIG.API + '/flightTimes',
            service = {
                getFlightTimesByStructureAndStretch: getFlightTimesByStructureAndStretch,
                saveFlightTime: saveFlightTime,
                saveTakeOffCapacity : saveTakeOffCapacity
            };

        return service;

        function getFlightTimesByStructureAndStretch(makerId, modelId, originId, destinyId){
            return $http.get(urlBase + "/" + makerId + "_" + modelId + "_" + originId + "_" + destinyId)
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('');
                });
        }

        function saveFlightTime(flightTime){
            return $http.put(flightTime._links.self.href, flightTime)
                .then(function(response){
                    messageService.registerUpdate('');
                    return response;
                })
                .catch(function(){
                    messageService.registerUpdateError('');
                });
        }

        function saveTakeOffCapacity(takeOffCapacity){
            return $http.put(takeOffCapacity._links.self.href, takeOffCapacity)
                .then(function(response){
                    messageService.registerUpdate('');
                    return response;
                })
                .catch(function(){
                    messageService.registerUpdateError('');
                });
        }
    }
})();
